import { render, staticRenderFns } from "./reduceInsurerTB.vue?vue&type=template&id=63e5e03c&scoped=true"
import script from "./reduceInsurerTB.vue?vue&type=script&lang=js"
export * from "./reduceInsurerTB.vue?vue&type=script&lang=js"
import style0 from "./reduceInsurerTB.vue?vue&type=style&index=0&id=63e5e03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5e03c",
  null
  
)

export default component.exports